import { render, staticRenderFns } from "./ReplacementEdit.vue?vue&type=template&id=024b0022&scoped=true&"
import script from "./ReplacementEdit.vue?vue&type=script&lang=js&"
export * from "./ReplacementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b0022",
  null
  
)

export default component.exports